import React, { useCallback } from 'react';
import { Switch as MantineSwitch } from '@mantine/core';

export const Switch = React.memo((props) => {
  const { title, name, value, onChange } = props;

  const handleChange = useCallback(() => {
    onChange(!value, name);
  }, [name, value, onChange]);

  return (
    <div className="flex items-center justify-between">
      <span className="mr-3 text-xs text-[#7f7f7f]">{title}</span>
      <MantineSwitch size="xs" checked={!!value} onChange={handleChange} />
    </div>
  );
});

export const SwitchView = React.memo((props) => {
  const { title, value } = props;
  return (
    <>
      <div className="p-4 flex items-center justify-between">
        <h5 id="model-checkpoints-entry" className="text-[#2d2d2d] text-xs  leading-[14px] font-bold font-gro">
          {title}
        </h5>
        <MantineSwitch size="xs" checked={!!value} disabled />
      </div>
      <div className="border-t border-[#efefef]" />
    </>
  );
});
